import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import Link from '@react/react-spectrum/Link';
import Hammer from '@react/react-spectrum/Icon/Hammer';

import { RootContext } from '../../../root/RootContext';
import { useSidebar } from '../../../views/App';

import './TargetSidebar.scss';

export default ({ instance }) => {
  let history = useHistory();
  const { hide: closeSidebar } = useSidebar();
  const { state } = useContext(RootContext);

  function handleConfigureClick() {
    history.push('/quick-setup');
    closeSidebar();
  }

  return (
    <div className="aep-sidebar">
      <section>
        <Heading size={2}>{state.activeTarget.clientCode}</Heading>
        <Heading variant="subtitle3">Target</Heading>
      </section>

      <section>
        <Heading variant="subtitle1">Actions</Heading>
        <div>
          <Button
            variant="primary"
            icon={<Hammer />}
            onClick={handleConfigureClick}
            quiet>
            Apply configuration
          </Button>
        </div>
      </section>

      <section>
        <Heading variant="subtitle1">Properties</Heading>

        <Heading variant="subtitle3">URL</Heading>
        <div>
          <Link href="https://experience.adobe.com/target" target="_blank">
            https://experience.adobe.com/target
          </Link>
        </div>
      </section>
    </div>
  );
};
